export default function AboutSection() {
  return (
    <section className="relative py-28 md:py-36 px-4 md:px-8 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <div className="flex items-center justify-center mb-10">
          <div className="w-8 h-8 border border-foreground-300 rotate-45 opacity-40" />
        </div>

        <p className="text-xs tracking-[0.25em] uppercase text-foreground-500 font-medium mb-10">
          About the Company
        </p>

        <p className="text-lg md:text-[21px] leading-[1.75] text-foreground-700 font-light max-w-[680px] mx-auto">
          The company is a professional engineering team focused on designing and developing
          modern digital software solutions for the iOS platform and related technologies.
          It builds scalable, maintainable, and high-performance systems with a strong focus
          on usability, stability, and long-term technical quality. The team follows modern
          software engineering practices, including clean architecture, performance optimization,
          and user-centered design. The company emphasizes continuous innovation, improvement
          of development workflows, and adoption of up-to-date engineering standards to deliver
          reliable and future-ready IT solutions. It actively explores new technologies and
          evolves its internal processes to maintain high technical excellence.
        </p>
      </div>
    </section>
  );
}